import jwtInterceptor from "@/plugins/jwtInterceptor";
import { emitter } from "@/main";
import { useAuthStore } from "@/stores/auth";


export const barcode = {
  handleScannedBarcode(barcodeString: string) {
    barcodeString.toUpperCase()
    if (barcodeString.substring(0, 3) === "RO.") {
      this.processRotableBarcode(barcodeString.slice(3))

      return
    }
    const snackbar: snackevent = {
      snackbarText: "These kind of barcodes we don't support yet.",
      snackbarTimeout: 6000,
    }
    emitter.emit('snackbar', snackbar)
  },
  async processRotableBarcode(code: string) {
    if (await this.checkIfRotableIsInUse(code) === true) {
      await this.returnTheTool(code)

      return
    }
    await this.claimTheTool(code)
  },
  async checkIfRotableIsInUse(psn: string) {
    const response = await jwtInterceptor.get('v1/claimedTool/in-use/' + psn)

    return !!(response && response.data)
  },
  async returnTheTool(psn: string) {
    const requestArray = {
      "psn": psn,
    }
    const response = await jwtInterceptor.delete('v1/claimedTool/return', { data: JSON.stringify(requestArray) }).catch(error => {
      const snackbar: snackevent = {
        snackbarText: "Oeps. catch an error, could not return the tool.",
        snackbarTimeout: 6000,
        error: error,
      }
      emitter.emit('snackbar', snackbar)
    })
    if (response && response.status === 202) {
      const snackbar: snackevent = {
        snackbarText: "Tool is successfully returned.",
        snackbarTimeout: 6000,
      }
      emitter.emit('snackbar', snackbar)

      return
    }
    if (response) {
      const snackbar: snackevent = {
        snackbarText: "Oeps. could not return the tool.",
        snackbarTimeout: 6000,
        error: response.data?.error ? response.data : undefined,
      }
      emitter.emit('snackbar', snackbar)
    }
  },
  async claimTheTool(psn: string) {
    const authStore = useAuthStore()
    const requestArray = {
      "usersign": authStore.getUsersign,
      "psn": psn,
    }
    const response = await jwtInterceptor.post('v1/claimedTool/register', JSON.stringify(requestArray)).catch(error => {
      const snackbar: snackevent = {
        snackbarText: "Oeps. catch an error, could not hand out the tool.",
        snackbarTimeout: 6000,
        error: error,
      }
      emitter.emit('snackbar', snackbar)
    })
    if (response && response.status === 200) {
      const snackbar: snackevent = {
        snackbarText: "Tool " + response.data.description + " " + response.data.serialNumber + " is now on your name.",
        snackbarTimeout: 6000,
      }
      emitter.emit('snackbar', snackbar)

      return
    }
    if (response) {
      const snackbar: snackevent = {
        snackbarText: "Oeps. could not hand out the tool.",
        snackbarTimeout: 6000,
        error: response.data?.error ? response.data : undefined,
      }
      emitter.emit('snackbar', snackbar)
    }
  },
}

export default barcode

